const smartAnalyzer = {
  state: {
    /* 자원 스마트 분석 팝업 */
    showRscPopup: false,
    objRscKeyList: [],
    /* 이벤트 스마트 분석 팝업 */
    showEventPopup: false,
    eventHistSeqNumbers: [],
  },
  mutations: {
    setShowRscPopup: (state, visible) => {
      state.showRscPopup = visible;
    },
    setObjRscKeyList: (state, objRscKeyList) => {
      state.objRscKeyList = objRscKeyList;
    },
    setShowEventPopup: (state, visible) => {
      state.showEventPopup = visible;
    },
    setEventHistSeqNumbers: (state, eventHistSeqNumbers) => {
      state.eventHistSeqNumbers = eventHistSeqNumbers;
    },
  },
  actions: {
    openResourceSmartAnalyzerPopup({ commit }, objRscKeyList) {
      commit('setObjRscKeyList', objRscKeyList);
      commit('setShowRscPopup', true);
    },
    closeResourceSmartAnalyzerPopup({ commit }) {
      commit('setShowRscPopup', false);
      commit('setObjRscKeyList', []);
    },
    openEventSmartAnalyzerPopup({ commit }, eventHistSeqNumbers) {
      commit('setEventHistSeqNumbers', eventHistSeqNumbers);
      commit('setShowEventPopup', true);
    },
    closeEventSmartAnalyzerPopup({ commit }) {
      commit('setShowEventPopup', false);
      commit('setEventHistSeqNumbers', []);
    },
  },
};

export default smartAnalyzer;



// WEBPACK FOOTER //
// ./src/store/modules/smart-analyzer.js